import React from "react";
import { CustomSection } from "components/MainSectionTemplate/types";
import HubSpotCompanyPanel from "HubSpot/HubSpotCompanyPanel";
import { CompanyFieldMetaData, CompanyFormState } from "shared/utils/fieldsHelper/companyFields";

export const hubSpotSection = (
  companyFormState: CompanyFormState,
  fieldMetaData: CompanyFieldMetaData,
): CustomSection => {
  return {
    ...fieldMetaData.hubSpot.fields(),
    type: "custom",
    key: "hsCompanySection",
    render: () => <HubSpotCompanyPanel
      key="hsCompanySection"
      companyFormState={companyFormState}
    />,
  }
}